"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Data = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Small = (0, _styledComponents.default)(_fonts.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));
var Data = _styledComponents.default.td.attrs(function (_ref) {
  var children = _ref.children;
  return {
    children: /*#__PURE__*/_react.default.createElement(Small, null, children)
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  vertical-align: middle !important;\n  padding: 0 0 0 10px !important;\n  height: 100%;\n"])));
exports.Data = Data;